'use client';

import useDictionary from '@modules/Dictionary/useDictionary';

export default function LogoFest({ logos = [] }) {
  const { dictionary } = useDictionary();
  if (!logos || logos.length === 0) {
    return null;
  }

  return (
    <section className="SiteFooter__logo-fest">
      <p className="SiteFooter__logo-fest__title">{dictionary?.footer?.featuredIn || 'Visit Telemark featured in'}</p>
      <div className="SiteFooter__logo-fest__logos">
        {logos.map((logo, index) => (
          <img
            key={index}
            src={logo.url}
            alt={logo.alt || dictionary?.image?.logoAlt || 'Logo'}
            className="SiteFooter__logo-fest-image"
          />
        ))}
      </div>
    </section>
  );
}
